<div *ngIf="lesson || box" class="print__buttons">
    <button mat-raised-button [routerLink]="['/teacher/prepare', lessonId, 'edit']">Вернуться</button>
    <button mat-raised-button color="primary" (click)="callPrint()">Напечатать</button>
</div>
<div *ngIf="boxes == null && errorMessage.message == null">
    <div class="block-center">
        <div class="wrapper">
            <mat-progress-spinner
                class="spinner"
                mode="indeterminate">
            </mat-progress-spinner>
        </div>
    </div>
    <div class="text-center" style="margin-top: 4px">
        <p *ngIf="errorMessage.boxID">
            Генерация
            <a [routerLink]="['/teacher/prepare' + lessonId + '/edit/box', errorMessage.boxID]">
                бокса №{{errorMessage.boxID}}
            </a> еще не началась.
        </p>
    </div>
</div>
<div *ngIf="errorMessage.message">
    <div class="text-center">
        {{ errorMessage.message }}
        <div *ngIf="errorMessage.boxID">
            <p>
                <a [routerLink]="['/teacher/prepare', lessonId, '/edit/box', errorMessage.boxID]">
                    Бокс №{{errorMessage.boxID}}
                </a> не был сгенирирован.
            </p>
        </div>
    </div>
</div>
<section class="print">
    <ng-template ngFor let-box [ngForOf]="boxes">
        <div *ngIf="box.description" class="page box-description">
            <span>
                <h3>Бокс {{ box.title }} ... Уровень {{ box.level.level }}</h3>
                <h1>{{ box.description }}</h1>
            </span>
            <span *ngIf="box.comment">
                <p class="box-description__comment">{{ box.comment }}</p>
            </span>
        </div>
        <table class="page" *ngFor="let rows of separateBy(box.cards, calculateCardsPerTable(box))"
               [ngClass]="getCorrectClass(box)">
            <tr *ngFor="let cells of separateBy(rows, calculateCardColumns(box))">
                <td class="print-card" *ngFor="let card of cells">
                    <div class="cardText" *ngIf="card.card_number != 9999999999">
                        <table class="cardHeader">
                            <tr>
                                <td class="number">№{{ card.card_number }}</td>
                                <td class="name">Уровень {{ box.level.level }}</td>
                                <td class="date text-right">{{ box.lesson_date | date: 'dd.MM.yyyy' }}</td>
                            </tr>
                            <tr>
                                <td class="instruction_text" colspan="3" style="text-align: center">
                                    {{ card.card_text }}
                                </td>
                            </tr>
                        </table>
                        <table height="80%" width="100%" [class.isLongCardHeader]="card.card_text?.length > 100">
                            <tr>
                                <td class="exercises" [class.long-text]="isBoxWithLongExercises(card)">
                                    <table class="exercises" [class.no-image]="!hasImage(box)"
                                           [class.full-width]="isBoxWithLongExercises(card)">
                                        <ul class="exercises-list">
                                            <li *ngFor="let exercise of card.exercises; let i = index;" 
                                                [class.insert]="isInsertType(exercise)"
                                                [ngStyle]="getListStyle(card)">
                                                <span>{{i+1}})</span>
                                                <span style="width: 95%;">
                                                    <div style="padding-left: 10px;">
                                                        <p *ngIf="showHint(card, exercise)" class="exercise_hint">{{exercise?.hint}}</p>
                                                    </div>
                                                    <div class="exercise" *ngIf="isTypeWithText(exercise)">
                                                        <span class="exercise-text" [class.exercise__for-rus]="exercise.subject_pk === 2">
                                                            <ng-container *ngIf="exercise.subject_pk !== 2">
                                                                <ng-katex *ngIf="isKatexFormat(exercise)"  class="katex" [class.frac]="exercise.text.includes('frac')"
                                                                    [equation]="exercise.text"></ng-katex>
                                                                <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)"  class="katex text"
                                                                    [paragraph]="exercise.text|exerciseFormat"></ng-katex-paragraph>
                                                            </ng-container>
                                                            <p><span *ngIf="exercise.subject_pk === 2" [outerHTML]="exercise.text"></span></p>
                                                        </span>

                                                        <span *ngIf="!checkLit(card.card_text) && !withoutDivedir(exercise)" class="divider"></span>
                                                    </div>
                                                    <div class="exercise" *ngIf="!isTypePuzzle(exercise) && isTypeWithQuestion(exercise) && !isInsertType(exercise)"
                                                        [class.logic]="isLogicType(exercise)"
                                                        [class.insert-text]="isInsertType(exercise)">
                                                        <ng-katex-paragraph *ngIf="!logicIncludeCasesConstruction(exercise)" 
                                                            class="exercise_text katex" [paragraph]="getLogicText(exercise)|exerciseFormat"></ng-katex-paragraph>
                                                        <ng-katex *ngIf="logicIncludeCasesConstruction(exercise)" 
                                                            class="exercise_text" [equation]="exercise?.text"></ng-katex>
                                                        <ng-container *ngIf="logicIncludeCasesConstruction(exercise)">
                                                            <br>
                                                            <ng-katex class="exercise_text katex" [equation]="getQuestionsText(exercise)"></ng-katex>
                                                        </ng-container>
                                                        <div *ngIf="exercise.words && exercise.words.length && !exercise.hint" class="answer-vars">
                                                            <span *ngFor="let word of exercise.words" class="answer-var">{{ word.word }},</span>
                                                        </div>
                                                        <div *ngIf="!isInsertType(exercise)" class="divider"></div>
                                                        <div *ngIf="!isInsertType(exercise) && !isInsertEng()" class="divider"></div>
                                                    </div>
                                                    <app-print-magic-box *ngIf="isMagicBox(exercise)"
                                                                        [exercise_text]="exercise.text"
                                                                        [page_size]="box.cards_format"
                                                                        [exercise_hint]="exercise.hint">
                                                    </app-print-magic-box>
                                                    <app-exercise-puzzle *ngIf="isTypePuzzle(exercise)"
                                                        [cardInstruction]="card.card_text"
                                                        [cardFormat]="box.cards_format"
                                                        [exercise]="exercise"
                                                        [index]="null"
                                                        [viewType]="'print'">
                                                    </app-exercise-puzzle>
                                                </span>
                                            </li>
                                        </ul>
                                    </table>
                                </td>
                                <td class="img" *ngIf="hasImage(box)">
                                    <img [src]="main_domain + box.sell_character_obj.black_image_url"
                                        [ngStyle]="{'height': getImageHeight(box)}" />
                                </td>
                            </tr>
                        </table>
                        <span class="box-number">Бокс {{ box.title }}</span>
                    </div>
                    <div *ngIf="card.card_number == 9999999999" class="cardText">
                        <table class="cardHeader">
                            <tr>
                                <td class="number"></td>
                                <td class="name"></td>
                                <td class="date text-right"></td>
                            </tr>
                            <tr>
                                <td class="instruction_text" colspan="3" style="text-align: center"></td>
                            </tr>
                        </table>
                        <table height="80%" width="100%">
                            <tr>
                                <td class="exercises">
                                    <table class="exercises">
                                        <tr>
                                            <td class="exercise">
                                                <div class="exercise">
                                                    <span class="number"></span>&nbsp;
                                                    <span></span>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td class="img"></td>
                            </tr>
                        </table>
                    </div>
                </td>
            </tr>
        </table>
    </ng-template>
</section>
